import React from "react";
import {
  useCreateCustomObjectGroupMutation,
  useGetCustomObjectGroupsQuery,
} from "../../../../generated/graphql";
import { AuthContext } from "../../../Authorization/AuthContext";
import { Box, FlexRow } from "../../../Common/__styles__/Layout";
import { Button } from "../../../Common/Button";
import {
  Header,
  HeaderTitle,
  HelperText,
  Section,
  SectionTitle,
} from "../../__styles__/Content";
import CustomObjectGroupsTable from "./CustomObjectGroupsTable";
import { useUpsertCustomObjectGroupModal } from "./upsertCustomObjectGroupModal";

const ObjectGroups = () => {
  const { account } = React.useContext(AuthContext);

  const { data, error, loading, previousData, refetch } =
    useGetCustomObjectGroupsQuery({
      variables: { accountId: account!.id },
    });

  const [createCustomObjectGroupMutation] =
    useCreateCustomObjectGroupMutation();

  const [showUpsertCustomObjectGroupModal] = useUpsertCustomObjectGroupModal({
    onSubmit: createCustomObjectGroupMutation,
    refetch,
  });

  if (error) {
    return <div />;
  }

  return (
    <Box>
      <Header accountSettings>
        <HeaderTitle accountSettings>Object settings</HeaderTitle>
      </Header>

      <Section>
        <FlexRow style={{ justifyContent: "space-between" }}>
          <SectionTitle>Groups</SectionTitle>

          <Button
            styleVariant="outlineLight"
            size="small"
            leftIconName="plus"
            onClick={() => {
              showUpsertCustomObjectGroupModal(null);
            }}
          >
            Add group
          </Button>
        </FlexRow>

        <HelperText>
          Add groups of related objects to organize map layers and configure
          object tables.
        </HelperText>
        <CustomObjectGroupsTable
          currentData={data?.account?.customObjectGroups ?? []}
          previousData={previousData?.account?.customObjectGroups ?? []}
          loading={loading}
          refetch={refetch}
        />
      </Section>
    </Box>
  );
};

export default ObjectGroups;
